<div class="logo-uploader__brand">
    <div class="logo-with-info">
        @if(!imgUrl){<img class="logo" src="../../../../../assets/svg-icons/icons/currency-icon.png" alt="">}
        @else{
            <img class="logo" [src]="imgUrl" alt="">
        }
        <hr>
        <div class="logo-info">
            <div class="logo-text">
                <p>{{'dimensions' | translate}}</p>
                <p class="text-right">{{'w_160px' | translate }} | {{'h_50px' | translate}}</p>
            </div>
            <div class="logo-text">
                <p>{{'size'| translate}}</p>
                <p class="text-right">200Kb</p>
            </div>
            <div class="logo-text">
                <p>{{'formats' | translate }}</p>
                <p class="text-right fw-700">{{'png_jpg_jpeg' | translate}}</p>
            </div>
        </div>
    </div>
    <input id="file" #fileInput type="file" [accept]="fileExtensions" class="fileUpload" 
        (change)="onValueChange(fileInput.files)" (click)="fileInput.value = null"  hidden/>
    <button class="btn btn-primary btn-primary--md btn-block" onclick="file.click(); return false">
        {{'chage_logo'| translate }}
    </button>
</div>


@if(showAlertPanel){<app-alert-panel [data]="alertPanelModel" (callbackEvent)="alertPanelReceiver($event)">
</app-alert-panel>}